import * as React from 'react';
import { ActorApiStringDisplay } from '../../../../../../../../../../../../../../../../../../../../../../actor/components/display/string';
import { useSanityLatestNewsById } from '../../../../../../../../../../../../../../../../../../../../../../sanity';

export const LatestNewsTitleContent = (props: {
  id: string,
}) => {
  const {
    id,
  } = props;
  const {
    data,
    isLoading,
    error,
  } = useSanityLatestNewsById(id);
  return (
    <ActorApiStringDisplay
      data={data?.title}
      isLoading={isLoading}
      error={error}
    />
  );
};
